<script setup>
import { ref, watch } from 'vue';
import { watchDebounced } from '@vueuse/core';
import AutocompleteField from '@/Components/AutocompleteField.vue';

const props = defineProps({
    selected: {
        type: [Object, null],
        default: null,
    },
    roles: {
        type: [Array],
        default: () => [],
    },
    bgColor: {
        type: [String, null],
        default: null,
    },
});
const userId = defineModel({
    type: [String, Number, null],
    required: true,
});

userId.value = props.selected?.id ?? null;

const search = ref('');
const items = ref(props.selected ? [props.selected] : []);
const lastSelected = ref(props.selected);

const loading = ref(false);
watchDebounced(
    search,
    async () => {
        if (
            search.value.length >= 3 &&
            search.value !== lastSelected.value?.username
        ) {
            try {
                loading.value = true;
                const response = await axios.get(route('api.user.index'), {
                    params: {
                        filter: {
                            search: search.value,
                            role: props.roles,
                        },
                    },
                });
                items.value = response.data;

                if (
                    lastSelected.value &&
                    !items.value.find(
                        (item) => item.id === lastSelected.value.id,
                    )
                ) {
                    items.value.push(lastSelected.value);
                }
            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                loading.value = false;
            }
        }
    },
    { debounce: 300 },
);

watch(userId, (value) => {
    if (!userId.value) return;
    lastSelected.value = items.value.find((item) => item.id === value);
});
const reset = () => {
    userId.value = props.selected?.id;
};

defineExpose({ reset });
</script>

<template>
    <AutocompleteField
        v-model="userId"
        v-model:search="search"
        :loading
        :items
        item-title="username"
        item-value="id"
        :custom-filter="() => true"
        :bg-color
    ></AutocompleteField>
</template>

<style scoped></style>
